/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sso_Select_Organization_TitleInputs */



/**
* | output |
* | --- |
* | "Select Organization" |
*
* @param {Auth_Sso_Select_Organization_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_select_organization_title = /** @type {((inputs?: Auth_Sso_Select_Organization_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_Select_Organization_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisation auswählen")
	return /** @type {LocalizedString} */ ("Select Organization")
});